import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useTranslation } from 'react-i18next';
import { AudienceDetailsTabsValues } from '../../types';
import { useAudienceTabs } from './hooks/useAudienceTabs';

export function AudienceTabs() {
  const { t } = useTranslation();
  const { activeTab, changeTab } = useAudienceTabs();

  return (
    <Tabs onChange={changeTab} value={activeTab}>
      <Tab data-test="audience-details-tab" label={t('Audience Details')} value={AudienceDetailsTabsValues.Details} />
      <Tab
        data-test="audience-criteria-tab"
        label={t('Audience Criteria')}
        value={AudienceDetailsTabsValues.Criteria}
      />
      <Tab data-test="audience-insights-tab" label={t('Insights')} value={AudienceDetailsTabsValues.Insights} />
    </Tabs>
  );
}
